import { render, staticRenderFns } from "./ManageVendorTable.vue?vue&type=template&id=4a8454d5&scoped=true&"
import script from "./ManageVendorTable.vue?vue&type=script&lang=js&"
export * from "./ManageVendorTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageVendorTable.vue?vue&type=style&index=0&id=4a8454d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8454d5",
  null
  
)

export default component.exports